import React from "react";
import styled from "styled-components";
import * as sanitizeHtml from "sanitize-html";
import { LinkStyle } from "storybook-components/Link";
import { H3, BodyStyle, ButtonTxtStyle } from "storybook-components/Typography";
import BlogArticleLink from "../BlogArticleLink";
import NotchedImg from "./NotchedImg";
import sanitizeSettings from "../../../config/sanitize-html";

const checkLongDescription = (node, longDescription) => {
  if (longDescription) {
    return (
      <>
        <DescriptionText
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              node.longDescription.childMarkdownRemark.html,
              sanitizeSettings
            )
          }}
        />
        <ContinueLink to={node.slug}>Read more</ContinueLink>
      </>
    );
  }
  return <ContinueLink to={node.slug}>Read more</ContinueLink>;
};

const checkHeroImage = (node, heroImage) => {
  if (heroImage) {
    return (
      <NotchedImg
        imageData={node.heroImage.gatsbyImageData}
        alt={node.heroImage.title}
        hasBorderRadius
      />
    );
  }
  return <NotchedImg alt="no-hero-image" />;
};

const PreviewWrapper = styled.div`
  width: 100%;
  padding: 24px 16px;
  border-bottom: 1px solid #000;
  display: flex;
  flex-direction: column;
  &:last-of-type {
    border-bottom: none;
  }
  ${props => props.theme.media.desktopUp`
    padding: 0 0 24px;
    flex-direction: row;
  `};
`;

const ImageCol = styled.div`
  margin-bottom: 32px;
  width: 100%;
  ${props => props.theme.media.desktopUp`
    margin-right: 2%;
    margin-bottom: 0;
    width: 50%;    
  `};
`;

const CopyCol = styled.div`
  width: 100%;
  ${props => props.theme.media.desktopUp`
    padding: 0;
    width: 48%;
  `};
`;

const PostTitle = styled(H3)`
  max-width: 560px;
  margin: 0 0 32px;
  color: ${({ theme }) => theme.colors.green5};
  &:hover {
    color: ${({ theme }) => theme.colors.gray12};
  }
  ${props => props.theme.media.desktopUp`
    font-size: 3rem;
  `};
`;

const TitleLink = styled(BlogArticleLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.green5};
  &:hover {
    color: ${({ theme }) => theme.colors.gray12};
  }
`;

const DescriptionText = styled.div`
  line-height: 1.5;
  max-width: 400px;
  ${BodyStyle};
  a {
    ${LinkStyle}
    margin-left: 0;
  }
`;

const ImageLink = styled(BlogArticleLink)`
  border-radius: 10px;
  display: block;
  overflow: hidden;
`;

const ContinueLink = styled(BlogArticleLink)`
  ${ButtonTxtStyle}
  margin-left: 0;
`;

export default ({ node }) => (
  <PreviewWrapper>
    <ImageCol>
      <ImageLink to={node.slug}>
        {checkHeroImage(node, node.heroImage)}
      </ImageLink>
    </ImageCol>

    <CopyCol>
      <PostTitle>
        <TitleLink to={node.slug}>{node.title}</TitleLink>
      </PostTitle>
      {checkLongDescription(node, node.longDescription)}
    </CopyCol>
  </PreviewWrapper>
);
